const getMovieLink = (moviePk, movieRoutesData, translation)  => {
    const { currentLang } = translation

    if(movieRoutesData && movieRoutesData.hasOwnProperty(moviePk) && movieRoutesData[moviePk].uri_list.hasOwnProperty(currentLang)) {
        return movieRoutesData[moviePk].uri_list[currentLang]
    } else {
        return false
    }
}

export default getMovieLink